import { useState, useRef, useEffect } from 'react';

export default function ImageWithFallback({ src, fallbackGradient, alt, className, style }) {
  const [status, setStatus] = useState('loading');
  const [activeSrc, setActiveSrc] = useState(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    setStatus('loading');
    setActiveSrc(null);

    if (!src) { setStatus('error'); return; }

    const el = wrapRef.current;
    if (!el) return;

    let cancelled = false;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !cancelled) {
          setActiveSrc(src);
          observer.disconnect();
        }
      },
      { rootMargin: '120px' }
    );
    observer.observe(el);

    return () => {
      cancelled = true;
      observer.disconnect();
    };
  }, [src]);

  return (
    <div ref={wrapRef} className={`img-fallback-wrap ${className || ''}`} style={style}>
      {status === 'loading' && <div className="skeleton img-skeleton" />}

      {activeSrc && (
        <img
          src={activeSrc}
          alt={alt || ''}
          className={`img-actual ${status === 'loaded' ? 'img-visible' : 'img-hidden'}`}
          onLoad={() => setStatus('loaded')}
          onError={() => setStatus('error')}
        />
      )}

      {status === 'error' && fallbackGradient && (
        <div className="img-gradient-fallback" style={{ background: fallbackGradient }} />
      )}
    </div>
  );
}
